module.exports = __webpack_public_path__ + "static/media/logZoomOut.b4fa25d0.svg";